import ProcessEngineType from 'library/src/processing/models/ProcessEngineType';
import StatisticIndicatorType from 'library/src/statistic/models/StatisticIndicatorType';
import { Reducer } from 'redux';
import {
    GET_STATISTICS_SUCCESS,
    LOAD_PROCESS_ENGINE_JOBS_SUCCESS,
    ON_SELECT_INDICATOR,
    ON_SELECT_PROCESS_ENGINE,
    ON_SELECT_STATISTIC_RECORD,
    VisioCropActionTypes,
} from '../actions/VisioCropActions';
import { VisioCropState } from '../models/VisioCropState';

const initialState: VisioCropState = {
  selectedProcessEngine: ProcessEngineType.VC_RAPESEED_FERTILIZATION,
  selectedIndicator: StatisticIndicatorType.NDVI,
  field_process_engine_jobs: null,
  statistics: {},
  selectedStatisticRecord: null,
};

const visioCropReducers: Reducer<VisioCropState, VisioCropActionTypes> = (
  state: VisioCropState = initialState,
  action: VisioCropActionTypes,
) => {
  switch (action.type) {
    case ON_SELECT_STATISTIC_RECORD:
      return {
        ...state,
        selectedStatisticRecord: action.payload.statisticRecord,
      };
    case ON_SELECT_INDICATOR:
      return {
        ...state,
        selectedIndicator: action.payload.indicator,
      };
    case GET_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: {
          ...action.payload.data,
        },
      };
    case ON_SELECT_PROCESS_ENGINE:
      return {
        ...state,
        selectedProcessEngine: action.payload.processEngineType,
      };
    case LOAD_PROCESS_ENGINE_JOBS_SUCCESS:
      return {
        ...state,
        field_process_engine_jobs: action.payload.jobs,
      };
    default:
      return state;
  }
};

export default visioCropReducers;
